module.exports = __webpack_public_path__ + "img/banner2_12.05ea0545.png";